export default {
  path: 'statuses',
  name: 'orders.statuses',
  component: () => import('@/views/admin/orders/default/statuses/Index'),
}